// extracted by mini-css-extract-plugin
export default {"title":"Logout_title__wKYKy","flex":"Logout_flex__S2iV1"};